var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNote = function SvgNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.083 3.917a.5.5 0 0 1 .5-.5h8.834a.5.5 0 0 1 .5.5v12.271l-4.13-2.541a1.5 1.5 0 0 0-1.573 0l-4.13 2.541V3.917Zm.5-1.5a1.5 1.5 0 0 0-1.5 1.5v13.166a.5.5 0 0 0 .762.426l4.893-3.01a.5.5 0 0 1 .524 0l4.893 3.01a.5.5 0 0 0 .762-.426V3.917a1.5 1.5 0 0 0-1.5-1.5H5.583ZM7.5 5.75a.5.5 0 0 0 0 1h5a.5.5 0 1 0 0-1h-5Z",
    fill: "#fff"
  })));
};

export default SvgNote;